export enum RequestDetailsTabKey {
	Parties = "parties",
	Details = "details",
	Attachments = "attachments",
	Correspondences = "correspondences",
	CommitteeMembers = "committee-members",
	PreviousStudies = "previous-studies",
	FollowUpStudy = "follow-up-study",
	StudiesComparison = "studies-comparison",
	LegalStudy = "legal-study",
	Decision = "decision",
	Sessions = "sessions",
	Prosecution = "prosecution",
	MemoExchange = "memo-exchange",
	InvestigationPlan = "investigation-plan",
	InvestigationReport = "investigation-report",
	GladAi = "glad-ai",
}
